import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import React, { useEffect, useState } from 'react';
import './settings.css';
import TabButton from 'components/Button/TabButton/TabButton';
import { ESettingsTabOptions, SideTabs } from 'enums/ESettingsTabOptions';
import { useParams, useNavigate } from 'react-router-dom';
import { GlobalPreferences } from '../GlobalPrefrences/GlobalPrefrences';
import LicenseAdminSetup from '../Licensing/LicenseAdminSetup';
import UserSetup from '../Licensing/userSetup';
import { setSettingsTab } from 'redux/reducers/settingsTabReducer';
import { useRMDispatch } from 'redux/hooks';
import { FindOrphanImages } from '../OrphanImages';
import { Support } from '../Support';

export const SettingsTabsContext = React.createContext(null);
export const SettingsTabs = (props) => {
  const { tab } = useParams();
  const navigate = useNavigate();
  const dispatch = useRMDispatch();
  const [tabIndex, setTabIndex] = useState<number>(ESettingsTabOptions.License);
  const [headers, setHeaders] = useState();

  useEffect(() => {
    const sideTab = SideTabs.find((sideTab) => sideTab.value === tab)?.key;
    setTabIndex(sideTab ?? ESettingsTabOptions.GlobalPreference);
    dispatch(setSettingsTab(tab ?? SideTabs[ESettingsTabOptions.GlobalPreference].value));
  }, [tab]);

  const changeTab = async (index: number) => {
    dispatch(setSettingsTab(SideTabs[index].value));
    navigate(`/settings/${SideTabs[index].value}`);
  };

  return (
    <>
      {headers}
      <SettingsTabsContext.Provider value={{ setHeaders }}>
        <Tabs
          id="settingstabs-wrapper"
          className="setup-tab h-[89.4%] flex"
          selectedIndex={tabIndex}
          onSelect={(index) => {
            if (index === tabIndex) {
              return false;
            }
            changeTab(index);
            return false;
          }}
        >
          <TabList id="settingstabs-tablist" className="setting-tab-list">
            <Tab>
              <TabButton
                titleTip={'Global Preference'}
                active={tab === SideTabs[ESettingsTabOptions.GlobalPreference].value}
                IconProps={{ name: 'GlobalPreferences', subfolder: 'Settings' }}
              />
            </Tab>
            <Tab>
              <TabButton
                titleTip={'Administrator'}
                active={tab === SideTabs[ESettingsTabOptions.Administrator].value}
                IconProps={{ name: 'AdminSetup', subfolder: 'Settings' }}
              />
            </Tab>
            <Tab>
              <TabButton
                titleTip={'License'}
                active={tab === SideTabs[ESettingsTabOptions.License].value}
                IconProps={{ name: 'License' }}
              />
            </Tab>
            <Tab>
              <TabButton
                titleTip={'Orphan Images'}
                active={tab === SideTabs[ESettingsTabOptions.OrphanImages].value}
                IconProps={{ name: 'OrphanImages', subfolder: 'Settings' }}
              />
            </Tab>
            <Tab>
              <TabButton
                titleTip={'Support'}
                active={tab === SideTabs[ESettingsTabOptions.Support].value}
                IconProps={{ name: 'Support' }}
              />
            </Tab>
          </TabList>
          <div
            id="settingtabs-tabpanel"
            className="flex flex-column content-width bg-white flex-1 overflow-hidden"
          >
            <TabPanel
              id="settingstabs-tabpanel-globalpreferences"
              className="bg-white min-h-0 overflow-hidden"
            >
              <GlobalPreferences />
            </TabPanel>
            <TabPanel id="settingstabs-tabpanel-usersetip" className="bg-white">
              <UserSetup />
            </TabPanel>
            <TabPanel id="settingstabs-tabpanel-licenseadmin">
              <LicenseAdminSetup {...props} />
            </TabPanel>
            <TabPanel id="settingstabs-tabpanel-findorphanimages" className="bg-white">
              <FindOrphanImages {...props} />
            </TabPanel>
            <TabPanel id="settingstabs-tabpanel-support">
              <Support />
            </TabPanel>
          </div>
        </Tabs>
      </SettingsTabsContext.Provider>
    </>
  );
};
